var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 19.7495V20.6857C48.7647 21.3983 48.496 21.984 48.0171 22.5631C46.3449 24.5823 43.6532 26.7584 41.7307 28.6525C40.7394 29.6304 39.7548 30.62 38.7953 31.6297L40.9397 44.4494C41.0916 47.1662 39.0773 48.6698 36.5324 47.6385L24.9676 41.6141L13.5947 47.5801C10.9046 48.7415 8.84033 47.1562 9.07229 44.2775L11.2017 31.6297C10.2104 30.5883 9.19578 29.5687 8.17281 28.5591C5.97667 26.3946 3.61031 24.3487 1.57604 22.0291C0.306084 19.9814 1.22559 18.0123 3.45511 17.3781L16.5385 15.4139L22.3893 3.59215C23.8262 1.50782 26.1808 1.52451 27.6077 3.59215L33.4585 15.4139L46.4684 17.3581C47.7217 17.6969 48.6579 18.4662 49 19.7495Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteFilled);
export default __webpack_public_path__ + "static/media/Favourite_filled.273a05186c7da60753f2ff8250a58e0d.svg";
export { ForwardRef as ReactComponent };